'use client';

import Script from 'next/script';

export default function TermlyCMP({ termlyId }: { termlyId: string }) {
  if (!termlyId) {
    return null;
  }

  return (
    <Script
      id="termly-script"
      strategy="afterInteractive"
      src={`https://app.termly.io/resource-blocker/${termlyId}?autoBlock=on`}
    />
  );
}
